<template>
  <div
    class="coinflip-coin"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
      '--size': `${size}px`,
      '--thickness': `${thickness}px`,
      '--faces': faces,
    }"
  >
    <v-img
      :src="coin[0].image"
      :width="size"
      :transition="false"
      aspect-ratio="1"
      contain
      class="coin--side coin--heads"
    />
    <div class="coin--edge">
      <div v-for="i in faces" :key="i" :style="{ '--i': i, }" />
    </div>
    <v-img
      :src="coin[1].image"
      :width="size"
      :transition="false"
      aspect-ratio="1"
      contain
      class="coin--side coin--tails"
    />
  </div>
</template>

<script>
export default {
  props: {
    coin: {
      type: Object,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 96,
    },
    faces: {
      type: Number,
      default: 40,
    },
    thickness: {
      type: Number,
      default: 10,
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
.coinflip-coin {
  display: block;
  position: relative;
  transform-style: preserve-3d;

  &.sheen .coin--side::after {
    animation: shine linear 1.5s 1;
  }

  .coin--side {
    overflow: hidden;
    border-radius: 50%;
    backface-visibility: hidden;

    &::after {
      display: block;
      position: absolute;
      bottom: 100%;
      left: calc(var(--size) / -2);
      width: calc(var(--size) * 2);
      height: calc(var(--size) / 1.5);
      opacity: 0.3;
      background: #fff;
      content: '';
      transform: translateZ(0);
      backface-visibility: hidden;
    }
  }

  .coin--heads {
    position: absolute;
    margin-right: 0;
    transform: translateZ(calc(var(--thickness) / 2));
  }

  .coin--tails {
    position: absolute;
    transform: rotateY(180deg) rotateZ(180deg) translateZ(calc(var(--thickness) / 2));
  }

  .coin--edge {
    transform-style: preserve-3d;

    div {
      --edge-face-length: calc(3.14 * var(--size) / var(--faces));
      --half-edge-face-length: var(--edge-face-length) / 2;
      --half-size: var(--size) / 2;
      --half-thickness: var(--thickness) / 2;

      position: absolute;
      width: var(--thickness);
      height: var(--edge-face-length);
      background-color: grey(500);
      transform:
        translateY(calc(var(--half-size) - var(--half-edge-face-length)))
        translateX(calc(var(--half-size) - var(--half-thickness)))
        rotateZ(calc(360deg / var(--faces) * var(--i) + 90deg))
        translateX(calc(var(--half-size)))
        rotateY(90deg);
    }
  }
}

@keyframes shine {
  0%,
  15% {
    transform: translateY(calc(var(--size) * 2)) rotate(-40deg);
  }

  50% {
    transform: translateY(calc(var(--size) * -1)) rotate(-40deg);
  }
}
</style>
